module.exports = __webpack_public_path__ + "fonts/9bd8d8832353c3390303fbb6dc974e12-SocialBrands-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SocialBrands-Regular.ttf
// module id = 359
// module chunks = 0